// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"2263":"80ae184f0be8cb80","6321":"e8e432efc6a0874e","7776":"b2ab4ae247119784"}[chunkId] + ".js";
};